import { useEffect, useState } from "react";
import { fetchPublicProperty } from "../services/publicPropertyApi";

const usePublicProperty = (idOrSlug) => {
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!idOrSlug) {
      setLoading(false);
      setProperty(null);
      return;
    }

    let mounted = true;
    setLoading(true);
    setError("");

    fetchPublicProperty(idOrSlug)
      .then((result) => {
        if (mounted) {
          setProperty(result);
        }
      })
      .catch((requestError) => {
        if (mounted) {
          setError(requestError.message);
          setProperty(null);
        }
      })
      .finally(() => {
        if (mounted) {
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, [idOrSlug]);

  return { property, loading, error };
};

export default usePublicProperty;
